import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { getAuth, onAuthStateChanged } from "firebase/auth";


const TYPE_OPTIONS = [
  { value: "kitchen", label: "Kitchen" },
  { value: "wardrobe", label: "Wardrobe" },
  { value: "bathroom", label: "Bathroom" },
  { value: "other", label: "Other" },
];

const STATUS_OPTIONS = [
  { value: "concept", label: "Concept" },
  { value: "in_progress", label: "In progress" },
  { value: "built", label: "Built" },
];




export default function ProjectEdit() {
  const { id } = useParams();

  const [p, setP] = useState(null);
  const [media, setMedia] = useState([]);

  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(true);

  const [uploadKind, setUploadKind] = useState("image"); // photo|video|model|doc
  const [uploading, setUploading] = useState(false);

  const [tagsText, setTagsText] = useState(""); // "tag1, tag2"
const [tagsSaving, setTagsSaving] = useState(false);

const photos = media.filter((m) => m.type === "image");
const coverUrl = p ? (p.cover || p.cover_image || "") : "";

  const ORIGIN = "https://modularobjects.com";
const absUrl = (u) => (u?.startsWith("http") ? u : `${ORIGIN}${u}`);

const API_ORIGIN = "https://modularobjects.com";

const LANG_OPTIONS = [
  { value: "sr", label: "SR" },
  { value: "en", label: "EN" },
  // dodaj dalje...
];

const [lang, setLang] = useState("sr");

// translation state (samo prevodiva polja)
const [tr, setTr] = useState({
  slug: "",
  title: "",
  brief: "",
  seo_title: "",
  seo_description: "",
  seo_image: "",
  cover_image: "",
  cta_primary_label: "",
  cta_primary_path: "",
  cta_secondary_label: "",
  cta_secondary_path: "",
});

async function loadDocs(projectId) {
  const docs = await authFetch(`https://modularobjects.com/marketing/api/admin/project-docs/${projectId}`);
  setP(prev => ({ ...(prev || {}), docs: Array.isArray(docs) ? docs : [] }));
}


function toAbs(url) {
  if (!url) return "";
  // već je apsolutan
  if (/^https?:\/\//i.test(url)) return url;
  // relativan -> dodaj domen
  return `${API_ORIGIN}${url.startsWith("/") ? "" : "/"}${url}`;
}

const [docLabel, setDocLabel] = useState("");
const [docFile, setDocFile] = useState(null);

async function uploadDoc() {
  if (!docFile) return alert("Izaberi PDF");

  setUploading(true);
  try {
    setErr("");

    const fd = new FormData();
    fd.append("file", docFile);
    fd.append("label", docLabel || "PDF");

    const j = await authFetch(
      `https://modularobjects.com/marketing/api/admin/project-docs/${id}`,
      { method: "POST", body: fd } // authFetch već dodaje Bearer token
    );

    // backend vraća { ok:true, docs:[...] }
    setP(prev => ({ ...(prev || {}), docs: j.docs || [] }));
    setDocLabel("");
    setDocFile(null);
  } catch (e) {
    alert(e.message || "Upload failed");
  } finally {
    setUploading(false);
  }
}

async function loadTranslation(projectId, lng) {
  const j = await authFetch(
    `https://modularobjects.com/marketing/api/admin/projects/${projectId}/i18n?lang=${lng}`
  );

  setTr({
    slug: j.slug || p?.slug || "",
    title: j.title || "",
    brief: j.brief || "",
    seo_title: j.seo_title || "",
    seo_description: j.seo_description || "",
    seo_image: j.seo_image || "",
    cover_image: j.cover_image || "",
    cta_primary_label: j.cta_primary_label || "",
    cta_primary_path: j.cta_primary_path || "",
    cta_secondary_label: j.cta_secondary_label || "",
    cta_secondary_path: j.cta_secondary_path || "",
  });
}

async function saveTranslation(projectId, lng) {
  await authFetch(
    `https://modularobjects.com/marketing/api/admin/projects/${projectId}/i18n?lang=${lng}`,
    {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(tr),
    }
  );
}


async function saveTags() {
  setTagsSaving(true);
  try {
    setErr("");

    const tags = tagsText
      .split(",")
      .map((t) => t.trim())
      .filter(Boolean);

    await authFetch(`https://modularobjects.com/marketing/api/admin/projects/${id}/tags`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ tags }),
    });

    // refresh projekta (da se tags u p usklade)
    const proj = await authFetch(`https://modularobjects.com/marketing/api/admin/projects/${id}`);
    setP(proj);

    setTagsText((proj?.tags || []).join(", "));

    await loadDocs(id);

    alert("✅ Tags saved");
  } catch (e) {
    console.error("❌ save tags:", e);
    setErr(e.message || "Tags save failed");
  } finally {
    setTagsSaving(false);
  }
}


  async function authFetch(url, options = {}) {
    const auth = getAuth();
    const user = auth.currentUser;
    if (!user) throw new Error("Not logged in");

    const token = await user.getIdToken(); // bez true

    const res = await fetch(url, {
      ...options,
      credentials: "include",
      headers: {
        ...(options.headers || {}),
        Authorization: `Bearer ${token}`,
      },
    });

    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data?.error || data?.message || `HTTP ${res.status}`);
    return data;
  }

  useEffect(() => {
     if (!id) return;
  const auth = getAuth();

  const unsub = onAuthStateChanged(auth, async (user) => {
    if (!user) {
      setErr("Not logged in");
      setP(null);
      setMedia([]);
      setLoading(false);
      return;
    }

    try {
      setErr("");
      setLoading(true);

      const proj = await authFetch(`${ORIGIN}/marketing/api/admin/projects/${id}`);
      setP(proj);

      setTagsText((proj?.tags || []).join(", "));

      await loadDocs(id);

      const m = await authFetch(`${ORIGIN}/marketing/api/admin/project-media/${id}`);
      setMedia(Array.isArray(m) ? m : []);
    } catch (e) {
      console.error("❌ load:", e);
      setErr(e.message || "Failed to load");
      setP(null);
      setMedia([]);
    } finally {
      setLoading(false);
    }
  });

  (async () => {
    try {
      setErr("");
      await loadTranslation(id, lang);
    } catch (e) {
      setErr(e.message || "Translation load failed");
    }
  })();
}, [id, lang]); // ✅ bez p



  async function save() {
    if (!p) return;
    setSaving(true);
    try {
      setErr("");
      await authFetch(`https://modularobjects.com/marketing/api/admin/projects/${id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(p),
      });
      alert("✅ Saved");
    } catch (e) {
      console.error("❌ Save failed:", e);
      setErr(e.message || "Save failed");
      alert("❌ Save failed");
    } finally {
      setSaving(false);
    }
  }
  

  async function uploadFile(file) {
    setUploading(true);
    try {
      setErr("");

      const auth = getAuth();
      const user = auth.currentUser;
      if (!user) throw new Error("Not logged in");
      const token = await user.getIdToken();

      const fd = new FormData();
      fd.append("project_id", id);
      fd.append("kind", uploadKind);
      fd.append("file", file);

      const res = await fetch("https://modularobjects.com/marketing/api/admin/project-media/upload", {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: fd,
        credentials: "include",
      });

      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data?.error || "Upload failed");

      // očekujemo { ok:true, item: row }
      if (data?.item) setMedia((prev) => [data.item, ...prev]);
    } catch (e) {
      console.error("❌ upload:", e);
      setErr(e.message || "Upload failed");
    } finally {
      setUploading(false);
    }
  }

  async function setCover(url) {
  try {
    setErr("");

    const nextTr = {
      ...tr,
      seo_image: tr.seo_image || url,
      cover_image: url,
    };

    await authFetch(`${ORIGIN}/marketing/api/admin/projects/${id}/i18n?lang=${lang}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(nextTr),
    });

    setTr(nextTr);
    setP(prev => ({ ...(prev || {}), cover_image: url, cover: url }));
    alert("✅ Cover updated");
  } catch (e) {
    console.error("❌ set cover:", e);
    setErr(e.message || "Failed to set cover");
  }
}


  async function deleteMedia(mediaId) {
    try {
      setErr("");
      await authFetch(`https://modularobjects.com/marketing/api/admin/project-media/${mediaId}`, {
        method: "DELETE",
      });
      setMedia((prev) => prev.filter((x) => x.id !== mediaId));
    } catch (e) {
      console.error("❌ delete media:", e);
      setErr(e.message || "Delete failed");
    }
  }

  if (loading) return <div className="p-4">Loading…</div>;

  if (!p && err) {
    return (
      <div className="p-4 max-w-3xl mx-auto space-y-3">
        <div className="p-3 rounded border border-red-300 bg-red-50 text-red-700">{err}</div>
        <Link className="underline" to="/marketing/admin/projects">Back</Link>
      </div>
    );
  }

  if (!p) return <div className="p-4">No data</div>;

  return (
    <div className="p-4 max-w-3xl mx-auto space-y-4">
      <div className="flex items-center justify-between">
        <div className="text-2xl font-bold">Edit project</div>
        <Link className="underline" to="/marketing/admin/projects">Back</Link>
      </div>

      {err && (
        <div className="p-3 rounded border border-red-300 bg-red-50 text-red-700">{err}</div>
      )}

      <div className="flex items-center gap-2">
  <div className="text-sm font-semibold">Language:</div>
  <select
    className="border rounded px-3 py-2"
    value={lang}
    onChange={(e) => setLang(e.target.value)}
  >
    {LANG_OPTIONS.map(o => (
      <option key={o.value} value={o.value}>{o.label}</option>
    ))}
  </select>
</div>

      {/* BASIC FIELDS */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <label className="text-sm">
  Title
  <input
    className="w-full border rounded px-3 py-2"
    value={tr.title}
    onChange={(e) => setTr({ ...tr, title: e.target.value })}
  />
</label>

       <label className="text-sm">
  Slug
  <input
    className="w-full border rounded px-3 py-2"
    value={tr.slug}
    onChange={(e) => setTr({ ...tr, slug: e.target.value })}
  />
</label>

        <label className="text-sm md:col-span-2">
          Brief
          <textarea
  className="w-full border rounded px-3 py-2 min-h-[100px]"
  value={tr.brief}
  onChange={(e) => setTr({ ...tr, brief: e.target.value })}
/>
        </label>

        <label className="text-sm">
          Year
          <input className="w-full border rounded px-3 py-2"
            value={p.year || ""}
            onChange={(e) => setP({ ...p, year: e.target.value ? Number(e.target.value) : null })}
          />
        </label>

        <label className="text-sm">
          Published
          <select className="w-full border rounded px-3 py-2"
            value={p.is_published ? "1" : "0"}
            onChange={(e) => setP({ ...p, is_published: e.target.value === "1" })}
          >
            <option value="0">Draft</option>
            <option value="1">Published</option>
          </select>
        </label>

<label className="text-sm">
  Location
  <input
    className="w-full border rounded px-3 py-2"
    value={p.location || ""}
    onChange={(e) => setP({ ...p, location: e.target.value })}
    placeholder="npr. Belgrade"
  />
</label>


<label className="text-sm">
  Type
  <select
    className="w-full border rounded px-3 py-2"
    value={p.type || "other"}
    onChange={(e) => setP({ ...p, type: e.target.value })}
  >
    {TYPE_OPTIONS.map((o) => (
      <option key={o.value} value={o.value}>
        {o.label}
      </option>
    ))}
  </select>
</label>

<label className="text-sm">
  Status
  <select
    className="w-full border rounded px-3 py-2"
    value={p.status || "concept"}
    onChange={(e) => setP({ ...p, status: e.target.value })}
  >
    {STATUS_OPTIONS.map((o) => (
      <option key={o.value} value={o.value}>
        {o.label}
      </option>
    ))}
  </select>
</label>

<div className="md:col-span-2 p-3 border rounded space-y-2">
  <div className="font-semibold">Features</div>

  <label className="flex items-center gap-2 text-sm">
    <input
      type="checkbox"
      checked={!!p.has_scan}
      onChange={(e) => setP({ ...p, has_scan: e.target.checked ? 1 : 0 })}
    />
    Has 3D scan
  </label>

  <label className="flex items-center gap-2 text-sm">
    <input
      type="checkbox"
      checked={!!p.has_viewer}
      onChange={(e) => setP({ ...p, has_viewer: e.target.checked ? 1 : 0 })}
    />
    Has 3D viewer
  </label>

  <label className="flex items-center gap-2 text-sm">
    <input
      type="checkbox"
      checked={!!p.has_docs}
      onChange={(e) => setP({ ...p, has_docs: e.target.checked ? 1 : 0 })}
    />
    Has docs
  </label>

  <label className="flex items-center gap-2 text-sm">
    <input
      type="checkbox"
      checked={!!p.has_photos}
      onChange={(e) => setP({ ...p, has_photos: e.target.checked ? 1 : 0 })}
    />
    Has photos
  </label>
</div>

<div className="md:col-span-2 p-3 border rounded space-y-2">
  <div className="font-semibold">SEO</div>

  <label className="text-sm">
    SEO title
    <input
      className="w-full border rounded px-3 py-2"
      value={tr.seo_title}
onChange={(e) => setTr({ ...tr, seo_title: e.target.value })}
    />
  </label>

 <label className="text-sm">
  SEO description
  <textarea
    className="w-full border rounded px-3 py-2 min-h-[90px]"
    value={tr.seo_description}
    onChange={(e) => setTr({ ...tr, seo_description: e.target.value })}
  />
</label>

<label className="text-sm">
  SEO image (url)
  <input
    className="w-full border rounded px-3 py-2"
    value={tr.seo_image}
    onChange={(e) => setTr({ ...tr, seo_image: e.target.value })}
    placeholder="/marketing/uploads/..."
  />
</label>
</div>

<div className="md:col-span-2 p-3 border rounded space-y-2">
  <div className="font-semibold">Call to action</div>

  <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
    <label className="text-sm">
      Primary label
      <input className="w-full border rounded px-3 py-2"
        value={p.cta_primary_label || ""}
        onChange={(e) => setTr({ ...tr, cta_primary_label: e.target.value })}
      />
    </label>

    <label className="text-sm">
      Primary path/url
      <input className="w-full border rounded px-3 py-2"
        value={p.cta_primary_path || ""}
        onChange={(e) => setP({ ...p, cta_primary_path: e.target.value })}
        placeholder="/kuhinje ili https://..."
      />
    </label>

    <label className="text-sm">
      Secondary label
      <input className="w-full border rounded px-3 py-2"
        value={p.cta_secondary_label || ""}
        onChange={(e) => setP({ ...p, cta_secondary_label: e.target.value })}
      />
    </label>

    <label className="text-sm">
      Secondary path/url
      <input className="w-full border rounded px-3 py-2"
        value={p.cta_secondary_path || ""}
        onChange={(e) => setP({ ...p, cta_secondary_path: e.target.value })}
      />
    </label>
  </div>
</div>


      </div>

      <label className="text-sm">
  3D model code
  <input
    className="w-full border rounded px-3 py-2"
    value={p.model_code || ""}
    onChange={(e) => setP({ ...p, model_code: e.target.value.trim() })}
    placeholder="npr. KITCHEN_001"
  />
  <div className="text-xs opacity-60 mt-1">
    Mora postojati u /demo/3dmodels/models.json i materials_{`{code}`}.json
  </div>
</label>

<div className="md:col-span-2 p-3 border rounded space-y-2">
  <div className="font-semibold">Video & Social</div>

  <label className="text-sm block">
    YouTube URL
    <input
      className="w-full border rounded px-3 py-2"
      value={p.youtube_url || ""}
      onChange={(e) => setP({ ...p, youtube_url: e.target.value })}
      placeholder="https://www.youtube.com/watch?v=..."
    />
    <div className="text-xs opacity-60 mt-1">
      Može watch URL ili youtu.be link.
    </div>
  </label>

  <label className="text-sm block">
    Instagram URL
    <input
      className="w-full border rounded px-3 py-2"
      value={p.instagram_url || ""}
      onChange={(e) => setP({ ...p, instagram_url: e.target.value })}
      placeholder="https://www.instagram.com/p/...."
    />
    <div className="text-xs opacity-60 mt-1">
      Link do posta/reela/profila.
    </div>
  </label>
</div>

{p.model_code && (
  <Link
    to={`/viewer/${p.model_code}`}
    className="inline-flex px-4 py-2 rounded bg-black text-white"
  >
    Open 3D viewer
  </Link>
)}



      <button
        onClick={save}
        disabled={saving}
        className="px-4 py-2 rounded bg-black text-white disabled:opacity-50"
      >
        {saving ? "Saving…" : "Save"}
      </button>

      <button
  onClick={async () => {
    try {
      await saveTranslation(id, lang);
      alert(`✅ Saved translation (${lang})`);
    } catch (e) {
      setErr(e.message || "Translation save failed");
    }
  }}
  className="px-4 py-2 rounded border"
>
  Save translation ({lang})
</button>

      <div className="p-4 rounded border space-y-2">
  <div className="font-semibold">Tags</div>
  <div className="text-sm opacity-70">
    Unesi zarezom odvojene tagove (npr: walnut, belgrade, island).
  </div>
  <input
    className="w-full border rounded px-3 py-2"
    value={tagsText}
    onChange={(e) => setTagsText(e.target.value)}
    placeholder="tag1, tag2, tag3"
  />
  <button
    onClick={saveTags}
    disabled={tagsSaving}
    className="px-3 py-2 rounded border"
  >
    {tagsSaving ? "Saving…" : "Save tags"}
  </button>
</div>

<div className="p-4 rounded border space-y-3">
  <div className="font-semibold">Cover image</div>

  {coverUrl ? (
    <img
      src={toAbs(coverUrl)}
      alt="Cover"
      className="w-full h-56 object-cover rounded"
    />
  ) : (
    <div className="text-sm opacity-70">No cover set yet.</div>
  )}

  {photos.length > 0 && (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
      {photos.slice(0, 12).map((m) => (
        <button
          key={m.id}
          type="button"
          onClick={() => setCover(m.url)}
          className="border rounded overflow-hidden hover:opacity-90"
          title="Set as cover"
        >
          <img
            src={toAbs(m.url)}
            alt=""
            className="w-full h-20 object-cover"
          />
        </button>
      ))}
    </div>
  )}
</div>



      {/* MEDIA UPLOAD */}
      <div className="p-4 rounded border space-y-3">
        <div className="font-semibold">Media</div>

        <div className="flex gap-3 flex-wrap items-center">
          <select
            className="border rounded px-3 py-2"
            value={uploadKind}
            onChange={(e) => setUploadKind(e.target.value)}
          >
            <option value="image">Image</option>
            <option value="video">Video (mp4)</option>
            <option value="model">3D model (.glb)</option>
            <option value="scan">3D scan</option>
          </select>

          <input
            type="file"
            onChange={(e) => {
              const f = e.target.files?.[0];
              if (f) uploadFile(f);
              e.target.value = "";
            }}
            disabled={uploading}
          />

          {uploading && <div className="text-sm opacity-70">Uploading…</div>}
        </div>



        {/* MEDIA LIST */}
        {media.length === 0 ? (
          <div className="text-sm opacity-70">No media yet.</div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {media.map((m) => (
              <div key={m.id} className="border rounded p-2 space-y-2">
                <div className="text-xs opacity-70">{m.type}</div>

                {m.type === "image" && (
  <img src={toAbs(m.url)} alt={m.title || ""} className="w-full h-40 object-cover rounded" />
)}


{m.type !== "image" && (
  <a className="underline text-sm" href={toAbs(m.url)} target="_blank" rel="noreferrer">
    Open file
  </a>
)}

                <div className="flex gap-2">
                  {m.type === "image" && (
  <button className="px-2 py-1 border rounded" onClick={() => setCover(m.url)}>
    Set cover
  </button>
)}

                  <button className="px-2 py-1 border rounded" onClick={() => deleteMedia(m.id)}>
                    Delete
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}

</div>


 <div className="mt-8 p-4 border rounded">
  <h3 className="font-semibold mb-3">PDF dokumenti</h3>

  <div className="flex gap-2 items-center flex-wrap">
    <input
      value={docLabel}
      onChange={(e) => setDocLabel(e.target.value)}
      placeholder="Naziv (npr. Offer PDF)"
      className="border px-3 py-2 rounded w-64"
    />
    <input
  type="file"
  accept=".pdf,.dxf,.zip,.bom,application/pdf"
  onChange={(e) => setDocFile(e.target.files?.[0] || null)}
/>
    <button onClick={uploadDoc} className="px-4 py-2 rounded bg-black text-white">
      Upload
    </button>
  </div>

  <div className="mt-4 space-y-2">
  {(p?.docs || []).map((d) => (
    <div key={d.id} className="flex items-center justify-between gap-3 border rounded p-2">
      <div className="min-w-0">
        <div className="font-medium truncate">{d.label || "PDF"}</div>
        <div className="text-xs opacity-70 truncate">{d.url}</div>
      </div>

      <div className="flex gap-2">
        <a className="underline" href={toAbs(d.url)} target="_blank" rel="noreferrer">
          Open
        </a>

        <button
          className="text-red-600 underline"
          onClick={async () => {
            try {
              const j = await authFetch(
                `https://modularobjects.com/marketing/api/admin/project-docs/${id}/${d.id}`,
                { method: "DELETE" }
              );
              setP(prev => ({ ...(prev || {}), docs: j.docs || [] }));
            } catch (e) {
              alert(e.message || "Delete failed");
            }
          }}
        >
          Delete
        </button>
      </div>
    </div>
  ))}
</div>


      </div>
    </div>
  );
}
